import { Box } from "@mui/material";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import { BrandTabs } from "entities/pages/types";
import { PagesPageProvider, usePagesPage } from "modules/brands/context";
import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import PageHeading from "shared/components/PageHeading";
import PrimaryButton from "shared/components/PrimaryButton";
import Tabs from "./Tabs";
import PagesTab from "./Tabs/Content/PagesTab";
import SettingsTab from "./Tabs/Content/SettingsTab";
import { PagesTabs } from "./context/types";

const PagesContainer = () => (
  <PagesPageProvider>
    <Pages />
  </PagesPageProvider>
);

const Pages: FC = () => {
  const { pageDrawer, brandDetails, activeTab } = usePagesPage();
  const { id, tabId } = useParams();
  const navigate = useNavigate();

  const handleTabChange = (newTab: string) => {
    navigate(`/brands/${id}/${newTab}`);
  };

  const writeAccess = useRolePermission("brandsAndPages:write");
  const isPagesTab = tabId === BrandTabs.Pages;
  const isVisibleAddPageButton =
    isPagesTab && writeAccess.allowed && activeTab === PagesTabs.Preview;

  return (
    <FlexColumn>
      <PageHeading>
        {isVisibleAddPageButton ? (
          <PrimaryButton
            title="Add new page"
            size="medium"
            onClick={() => pageDrawer.openDrawer()}
          />
        ) : (
          <Box height="3rem" />
        )}
      </PageHeading>

      <Tabs
        selectedTab={(tabId ?? BrandTabs.Pages) as BrandTabs}
        setSelectedTab={handleTabChange}
        isMaintenanceMode={brandDetails?.isBrandMaintenanceMode ?? false}
      />

      {isPagesTab ? <PagesTab /> : <SettingsTab />}
    </FlexColumn>
  );
};

export default PagesContainer;
